/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Hint_ArmsInputs */

const en_us2_body_assessment_capture_hint_arms = /** @type {(inputs: Body_Assessment_Capture_Hint_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arms away from your body in an A, a hand's width between elbow and waist.`)
};

const pt_br2_body_assessment_capture_hint_arms = /** @type {(inputs: Body_Assessment_Capture_Hint_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braços afastados do corpo em forma de A, com um palmo entre o cotovelo e a cintura.`)
};

const es_419_body_assessment_capture_hint_arms = /** @type {(inputs: Body_Assessment_Capture_Hint_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brazos separados del cuerpo en forma de A, con un palmo entre el codo y la cintura.`)
};

const pt_pt2_body_assessment_capture_hint_arms = /** @type {(inputs: Body_Assessment_Capture_Hint_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braços afastados do corpo em forma de A, com um palmo entre o cotovelo e a cintura.`)
};

const fr_fr2_body_assessment_capture_hint_arms = /** @type {(inputs: Body_Assessment_Capture_Hint_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bras écartés du corps en A, une main de largeur entre le coude et la taille.`)
};

const de_de2_body_assessment_capture_hint_arms = /** @type {(inputs: Body_Assessment_Capture_Hint_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arme in A-Form vom Körper weg, eine Handbreit zwischen Ellbogen und Taille.`)
};

const it_it2_body_assessment_capture_hint_arms = /** @type {(inputs: Body_Assessment_Capture_Hint_ArmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braccia staccate dal corpo ad A, con un palmo tra gomito e vita.`)
};

/**
* | output |
* | --- |
* | "Arms away from your body in an A, a hand's width between elbow and waist." |
*
* @param {Body_Assessment_Capture_Hint_ArmsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_hint_arms = /** @type {((inputs?: Body_Assessment_Capture_Hint_ArmsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Hint_ArmsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_hint_arms(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_hint_arms(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_hint_arms(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_hint_arms(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_hint_arms(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_hint_arms(inputs)
	return en_us2_body_assessment_capture_hint_arms(inputs)
});
export { body_assessment_capture_hint_arms as "body-assessment.capture_hint_arms" }